import { SVGProps } from 'react'

export const StarIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
   <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none" {...props}>
    <g filter="url(#filter0_d_6487_3102)">
        <path d="M1.6971 10.1903C1.6971 10.1903 8.34916 10.0983 9.22442 9.22381C10.0997 8.34933 10.1975 1.69735 10.1975 1.69735C10.1975 1.69735 10.2895 8.34941 11.164 9.22467C12.0385 10.0999 18.6905 10.1978 18.6905 10.1978C18.6905 10.1978 12.0384 10.2898 11.1632 11.1643C10.2879 12.0388 10.1901 18.6907 10.1901 18.6907C10.1901 18.6907 10.098 12.0387 9.22356 11.1634C8.34908 10.2882 1.6971 10.1903 1.6971 10.1903Z" fill="white"/>
    </g>
    <defs>
        <filter id="filter0_d_6487_3102" x="7.82013e-05" y="7.82013e-05" width="20.3875" height="20.388" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset/>
        <feGaussianBlur stdDeviation="0.848594"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.71 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6487_3102"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6487_3102" result="shape"/>
        </filter>
    </defs>
    </svg>
  )
}
